export default function initGrayTabsSwitcher() {
	const elements = document.getElementsByClassName('jsGrayTabsSwitcher');
	if (elements.length == 0 || !elements) return;

	const hideAllClasses = (className, activePos) => {
		const classes = document.getElementsByClassName(className);

		classes.forEach( (classItem, idx) => {
			if (idx == activePos) {
				classItem.style.display = 'block';
			} else {
				classItem.style.display = 'none';
			}
		})
	};

	const changeClickersClasses = (elementsObj, activePos) => {
		elementsObj.forEach( (element, idx) => {
			if (idx == activePos) {
				element.classList.add('gray-tabs__element_active');
			} else {
				element.classList.remove('gray-tabs__element_active');
			}
		})
	};

	elements.forEach( (element) => {
		const className = element.dataset.classes;
		const tabsItems = element.querySelectorAll('.jsGrayTabsElement');

		hideAllClasses(className, 0);

		tabsItems.forEach((item, idx) => {
			item.addEventListener('click', () => {
				changeClickersClasses(tabsItems, idx);
				hideAllClasses(className, idx);
			})
		});
	});


}
